import React, { useCallback } from 'react';
import { usePermisConversation, type PermisKind } from '../../hooks/usePermisConversation';
import { usePermits } from '../../contexts/PermitsContext';
import { poolApplication } from '../../data/permis';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { PermisMessage } from './PermisMessage';
interface PermisDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
}
const placeholders: Record<PermisKind, string> = {
  projet: 'Décrivez votre projet, ex. « construire une piscine »…',
  details: 'Précisez votre projet…',
  conformite: 'Une question sur le règlement ?',
  documents: 'Une question sur les documents ?',
  frais: 'Une question sur les frais ?',
  succes: 'Un autre projet à déclarer ?'
};
export function PermisDialog({
  initialText,
  onClose,
  layoutId
}: PermisDialogProps) {
  const {
    addPermit
  } = usePermits();
  // La demande déposée apparaît aussitôt dans « Mes demandes de permis ».
  const submit = useCallback(() => addPermit(poolApplication), [addPermit]);
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    permitType,
    projectDetail,
    documentsAttached,
    pickType,
    pickDetail,
    confirmRules,
    attachDocuments,
    payFee,
    liveAtnaId,
    lastAtnaKind
  } = usePermisConversation(initialText, submit);
  return <AtnaDialogShell layoutId={layoutId} subtitle="Demande de permis" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Vérifiez les exigences avant de déposer votre demande." prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    placeholder: placeholders[lastAtnaKind ?? 'projet']
  }} renderAtna={(kind, live) => <PermisMessage kind={kind as PermisKind} live={live} permitType={permitType} projectDetail={projectDetail} documentsAttached={documentsAttached} onPickType={pickType} onPickDetail={pickDetail} onConfirmRules={confirmRules} onAttachDocuments={attachDocuments} onPayFee={payFee} onClose={onClose} data-id="element-2298" data-mp="318o5sdukgy81" />} data-id="element-2297" data-mp="1lt73mqxeyusw" />;
}